export function compileImports(): string {
  return `const {createCodeNode, createStructureNode, createDummyNode} = require("@cranq/runtime");`;
}
